import { css } from "@agapi/ui/panda/css";

export const richTextStyles = css.raw({
  "& h1": {
      textStyle: "h2",
      pt: "3",
      pb: "4",
  },
  "& h2": {
      textStyle: "h3",
      pt: "3",
      pb: "4",
  },
  "& h3": {
      textStyle: "h4",
      pt: "3",
      pb: "4",
  },
  "& h4": {
      textStyle: "h5",
      pt: "3",
      pb: "4",
  },
  "& h5": {
      textStyle: "h6",
      pt: "3",
      pb: "4",
  },
  "& h6": {
      textStyle: "h6",
      pt: "3",
      pb: "4",
  },
  "& p": {
      textStyle: "body",
      pb: "4",
  },
  "& p:first-of-type": {
      pb: "5",
  },
  "& tr, & td": {
  },
  "& ul": {
      listStyle: "disc",
      listStylePosition: "inside",
      pb: '3',
      "& p": {
          display: "inline",
      }
  },
  "& a": {
      textDecoration: "underline",
  }
});
